import img1 from "../../assets/products/Furniture/6BOeWN4bBXsL0sSlfmS3uG5zGwA5FLLLo1Pv1LP0.jpg";
import img2 from "../../assets/products/Furniture/7PqbHJc9Uhz1MPejlVRdBz4WRj93qUQo1Iyyh5dN.jpg";
import img3 from "../../assets/products/Furniture/9VQsSwJtRaXSeTbYZQ19w9KW6zI24dstUVVL46N9.jpg";
import img9 from "../../assets/products/Furniture/CoFKWJWlNeOQPXRxYJKgQL8XO53QqkqK2YCdveEl.jpg";
import img14 from "../../assets/products/Furniture/j1ZbKpRX0efNBGP2FlJJHgJhxDUVNvJxh5c5KKP9.jpg";
import img15 from "../../assets/products/Furniture/qICpZww4ddxITVpDBzIeEKGHVaUJgSeIWuhBAbo8.webp";
import img13 from "../../assets/products/Furniture/FAQbiBErfkAsy7vLqkrtvUxkQTTam3jcUuuwOqKP.webp";
import img21 from "../../assets/products/Furniture/NGABOWvDKcuqiQFvHFogIMgVxbjdZWWJ62pl2Sig.jpg";
import img30 from "../../assets/products/Furniture/UBQDjp6OWJW0lPHCByiQ3qFFbwFVbfy9giv4ZNyP.jpg";
import img24 from "../../assets/products/Furniture/OeCgDJG1yUgRoDI8wH8rSnSyJQKgnzRezmQ2qwRL.webp";
import img29 from "../../assets/products/Furniture/s5LUDgU9DrRVobJjujx9Pje4OgBbZcQceX1j1dRG.webp";
import img17 from "../../assets/products/Furniture/aKuFkTuGIQmPvCGuXfgsu1CKrEaAKtoxcIwtdGbc.jpg";
// Extra furniture shots for detail galleries
import imgG1 from "../../assets/products/Furniture/367QXEbgBoB7X5WZF6CaxVmI8f1pQFXZp9FlRfMW.jpg";
import imgG2 from "../../assets/products/Furniture/c5xXpEifWzoS8szx8RMZ6ShMi4rIxHIhgwDKU3pC.jpg";
import imgG3 from "../../assets/products/Furniture/bq2j4Vj5OqwvaHcxRPnDqee4bJpFAxHtsRwDGmGL.jpg";
import imgG4 from "../../assets/products/Furniture/jn8EhVq8Ru2bXLAOXkTDj582Y3j52VeGGRHzQN2W.jpg";
import imgG5 from "../../assets/products/Furniture/od2ThmghE7rRLAe4Qe1luNWmVHrICDjO7q86CUCw.jpg";
import imgG6 from "../../assets/products/Furniture/kFvIG2i45Si7fm6Nl3T60P4aqQI7k2O3YoBbjMEy.jpg";
import imgG7 from "../../assets/products/Furniture/nXQ4rC9gmh6j6OGsZ0aUg5M7FF5VyC5zbkTcKBUp.jpg";
import imgG8 from "../../assets/products/Furniture/FA5C65Vj1azjGHWqxOsifLZwS5zxoNj8PEG90ipv.jpg";
import imgG9 from "../../assets/products/Furniture/RUBLt7YDnfXKSfW6Fd7QU6YMyUlMpNg4OAGVGTWy.jpg";
import imgG10 from "../../assets/products/Furniture/LM4sBNHhKy4zRyiZdVYxl3OJPrjs8WjqDsCc9NUJ.jpg";
import imgG11 from "../../assets/products/Furniture/qIwyBYsK44XPbgkGnjNV8RXq1G1NequLIbtPgoJT.jpg";
import imgG12 from "../../assets/products/Furniture/xAQoWqzDX3VYaFhCRueDeW4JEMOTaXE6wEA1bhYo.jpg";
import imgG13 from "../../assets/products/Furniture/YReshThoFyFr0qmPZ8ny7LQOSS9xrSO6qsJcdfLh.webp";
import imgG14 from "../../assets/products/Furniture/uHqLbzZA5sayNwSdXDRCFijP7rz5RTpmCtyt8p1Z.jpg";
import imgG15 from "../../assets/products/Furniture/0FMZoi8gFfaLUiYxtuXhHqplv2ORH2ALK9fuapMB.jpg";
import imgG16 from "../../assets/products/Furniture/oMjXo2Etg7K2bn5OuD4jvGE4OcalxM9FtMsMJEqD.webp";
import imgG17 from "../../assets/products/Furniture/dyoKjugH3bBAMxViX7ZwWWcEt6E8OHkz1UIS6Aga.jpg";
import imgG18 from "../../assets/products/Furniture/EcbXi0sDNKSGCScvwNexbUbxLQUnGhBXkCYlSUaY.webp";
import imgG19 from "../../assets/products/Furniture/QE5ch7JI2cOuPm20Jdgqmkg4iRkHX7JcBc8bLWxT.webp";
import imgG20 from "../../assets/products/Furniture/asf7ecvGhjhVI2KiCvFGzTFChyIcdLB5rHNI4v9P.jpg";
import imgG21 from "../../assets/products/Furniture/wAKDfXbqDkyzpvRK7FFJF0KxGypTbTy30PWIEeXD.jpg";
import imgG22 from "../../assets/products/Furniture/AToQ2F1MdBsDfmOSgcWDQuuep42ClB7DeCxpyOKX.webp";
import imgG23 from "../../assets/products/Furniture/zfggdgjmB24pQeml9V6jxG0HWw2ny1fBRorsbfwp.webp";


const furnitureImageMap = {
  "fur-sofa-01": img1,
  "fur-desk-01": img2,
  "fur-wardrobe-01": img3,
  "fur-bed-01": img9,
  "fur-dining-01": img14,
  "fur-workstation-01": img15,
  "fur-chair-01": img13,
  "fur-tv-01": img21,
  "fur-conference-01": img30,
  "fur-reception-01": img24,
  "fur-coffee-01": img29,
  "fur-study-01": img17,
  // Gallery extras
  "fur-sofa-g2": imgG1,
  "fur-sofa-g3": imgG2,
  "fur-sofa-g4": imgG3,
  "fur-desk-g2": imgG4,
  "fur-desk-g3": imgG5,
  "fur-wardrobe-g2": imgG6,
  "fur-wardrobe-g3": imgG7,
  "fur-bed-g2": imgG8,
  "fur-bed-g3": imgG9,
  "fur-dining-g2": imgG10,
  "fur-dining-g3": imgG11,
  "fur-workstation-g2": imgG12,
  "fur-workstation-g3": imgG13,
  "fur-chair-g2": imgG14,
  "fur-chair-g3": imgG15,
  "fur-tv-g2": imgG16,
  "fur-tv-g3": imgG17,
  "fur-conference-g2": imgG18,
  "fur-conference-g3": imgG19,
  "fur-reception-g2": imgG20,
  "fur-reception-g3": imgG21,
  "fur-coffee-g2": imgG22,
  "fur-coffee-g3": imgG23,
  "fur-study-g2": imgG1,
  "fur-study-g3": imgG4,
};

/** Public paths for non-furniture catalog galleries */
const publicImageMap = {
  "gl-plot-res-01": "/assets/images/projects/project-1.jpg",
  "gl-plot-res-g2": "/assets/images/projects/project-2.jpg",
  "gl-plot-res-g3": "/assets/images/projects/project-3.jpg",
  "gl-plot-com-01": "/assets/images/projects/project-2.jpg",
  "gl-plot-com-g2": "/assets/images/projects/project-4.jpg",
  "gl-plot-com-g3": "/assets/images/projects/project-1.jpg",
  "gl-flat-1200": "/assets/images/projects/project-3.jpg",
  "gl-flat-g2": "/assets/images/projects/project-4.jpg",
  "gl-flat-g3": "/assets/images/small/small-1.jpg",
  "ex-dhk-ctg": "/assets/images/products/product-2.jpg",
  "ex-dhk-syl": "/assets/images/products/product-3.jpg",
  "ex-route-g2": "/assets/banner/banner-1.jpg",
  "ex-route-g3": "/assets/banner/banner-2.jpg",
  "hj-economy": "/assets/images/products/product-4.jpg",
  "hj-vip": "/assets/images/products/product-5.jpg",
  "hj-pkg-g2": "/assets/images/small/small-2.jpg",
  "hj-pkg-g3": "/assets/images/small/small-3.jpg",
  "mt-sedan": "/assets/images/products/product-6.jpg",
  "mt-suv": "/assets/images/products/product-1.jpg",
  "mt-vehicle-g2": "/assets/images/small/small-4.jpg",
  "mt-vehicle-g3": "/assets/images/small/small-5.jpg",
  "sk-professional": "/assets/images/products/product-2.jpg",
  "sk-ielts": "/assets/images/products/product-3.jpg",
  "sk-course-g2": "/assets/images/svg/features-1.svg",
  "sk-course-g3": "/assets/images/svg/startup.svg",
  "sf-erp": "/assets/images/svg/features-2.svg",
  "sf-pos": "/assets/images/svg/email-campaign.svg",
  "sf-soft-g2": "/assets/images/svg/file-searching.svg",
  "sf-soft-g3": "/assets/images/svg/report.svg",
  "dg-seo": "/assets/images/svg/email-campaign.svg",
  "dg-brand": "/assets/images/svg/features-1.svg",
  "dg-digital-g2": "/assets/images/svg/features-2.svg",
  "dg-digital-g3": "/assets/images/svg/startup.svg",
  "hd-cox-3n": "/assets/banner/banner-3.jpg",
  "hd-st-martin": "/assets/banner/banner-1.jpg",
  "hd-tour-g2": "/assets/images/small/small-6.jpg",
  "hd-tour-g3": "/assets/images/small/small-7.jpg",
  "iu-group-unit": "/assets/images/logo.png",
  "iu-group-g2": "/assets/images/iconicunity.png",
  "iu-group-g3": "/assets/images/greenland.png",
};

function resolveByKey(key) {
  if (!key) return null;
  if (furnitureImageMap[key]) return furnitureImageMap[key];
  if (publicImageMap[key]) return publicImageMap[key];
  return null;
}

export function resolvePortalProductImage(product) {
  if (product?.image_url) {
    return product.image_url;
  }

  if (Array.isArray(product?.gallery_urls) && product.gallery_urls[0]) {
    return product.gallery_urls[0];
  }

  const fromKey = resolveByKey(product?.image_key);
  return fromKey || null;
}

/**
 * Returns ordered unique gallery URLs for the detail page.
 * Falls back to the primary image when no gallery keys resolve.
 */
export function resolvePortalProductGallery(product) {
  const urls = [];
  const seen = new Set();

  const push = (url) => {
    if (!url || seen.has(url)) return;
    seen.add(url);
    urls.push(url);
  };

  const remoteUrls = Array.isArray(product?.gallery_urls)
    ? product.gallery_urls
    : [];
  remoteUrls.forEach((url) => push(url));

  const keys = Array.isArray(product?.gallery_keys) ? product.gallery_keys : [];
  keys.forEach((key) => push(resolveByKey(key)));

  push(resolvePortalProductImage(product));

  return urls;
}

export default furnitureImageMap;
